import { RootState } from 'internal/rootReducer';

export const selectLocale = (state: RootState): string | undefined => state.appState.locale;
